import salesDashboard from "./sales-dashboard";

// 콘솔 밖 경로(/api/integrated-viewer). api.console.dashboard 는 관리자 대시보드다.
export const integratedViewer = {
    salesDashboard,
};
